// left off @ 8:03

import { useEffect } from "react";

import { CheckOutlined } from "@material-ui/icons";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import Header from "./Header";
import Home from "./Home";
import Checkout from "./Checkout";
import Login from "./Login";
import Payment from "./Payment";
import Orders from "./Orders";

import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";

import { useStateValue } from "./StateProvider";

import "./App.css";

const promise = loadStripe(
  "pk_test_51Jlo0xJPTRMrMltmuPn3V5qq9Vj2XYXSWU4RAMXqcmIa9Uzeqzpescsp6SM9Dnbd7G76MFIh5p8Kb6IO4BRuQWTZ00j5uVb5QY"
);

function App() {
  const [{}, dispatch] = useStateValue();

  useEffect(() => {
    onAuthStateChanged(auth, (authUser) => {
      console.log("onAuthStateChanged: ", authUser);

      if (authUser) {
        // user login / was logged in

        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      } else {
        // user is logged out

        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, []);

  return (
    <Router>
      <div className="app">
        <Switch>
          <Route path="/login">
            <Login />
          </Route>

          <Route path="/checkout">
            <Header />
            <Checkout />
          </Route>

          <Route path="/payment">
            <Header />
            <Elements stripe={promise}>
              <Payment />
            </Elements>
          </Route>

          <Route path="/orders">
            <Header />
            <Orders />
          </Route>

          <Route path="/">
            <Header />
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
